module.exports = __webpack_public_path__ + "img/icon-cancel.d9af3b48.svg";